import * as React from 'react';
import { cn } from '@/lib/utils';

const ProfileBanner = React.forwardRef(({ className, ...props }, ref) => (
  <section
    ref={ref}
    className={cn('c-profile-banner', 'relative w-full', className)}
    {...props}
  />
));
ProfileBanner.displayName = 'ProfileBanner';

const ProfileBannerBgWrapper = React.forwardRef(({ className, children, ...props }, ref) => (
  <figure
    ref={ref}
    className={cn('relative', className)}
    {...props}
  >
    <div className="absolute inset-0 rounded-xl bg-black/50" />
    {children}
  </figure>
));
ProfileBannerBgWrapper.displayName = 'ProfileBannerBgWrapper';

const ProfileBannerBg = React.forwardRef(({ src, alt = '', className, ...props }, ref) => (
  <img
    ref={ref}
    src={src}
    alt={alt}
    className={cn('h-[160px] w-full rounded-xl object-cover', className)}
    {...props}
  />
));
ProfileBannerBg.displayName = 'ProfileBannerBg';

const ProfileBannerInner = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('relative z-20 -mt-[136px] flex w-full flex-col items-center gap-8 p-8 md:flex-row md:items-start', className)}
    {...props}
  />
));
ProfileBannerInner.displayName = 'ProfileBannerInner';

const ProfileBannerHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-grow flex-wrap-reverse items-center justify-center gap-4 md:justify-between', className)}
    {...props}
  />
));
ProfileBannerHeader.displayName = 'ProfileBannerHeader';

const ProfileBannerData = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('grow text-center md:text-left', className)}
    {...props}
  />
));
ProfileBannerData.displayName = 'ProfileBannerData';

const ProfileBannerTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn('mb-0 mt-1 text-2xl font-bold text-primary-dark md:text-white', className)}
    {...props}
  />
));
ProfileBannerTitle.displayName = 'ProfileBannerTitle';

const ProfileBannerInfoWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-col items-center sm:flex-row sm:items-start sm:gap-4', className)}
    {...props}
  />
));
ProfileBannerInfoWrapper.displayName = 'ProfileBannerInfoWrapper';

const ProfileBannerInfo = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('flex flex-wrap items-center gap-2 text-sm font-light text-primary-dark md:text-white [&>svg]:w-4', className)}
    {...props}
  />
));
ProfileBannerInfo.displayName = 'ProfileBannerInfo';

export { ProfileBanner, ProfileBannerBgWrapper, ProfileBannerBg, ProfileBannerInner, ProfileBannerHeader, ProfileBannerData, ProfileBannerTitle, ProfileBannerInfoWrapper, ProfileBannerInfo };
